import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CitiesService {
	constructor(private http: HttpClient) {}

	public getCities() {
		const url = environment.backend.citiesURL + '/cities?active=true';
		return this.http.get(url);
	}
}
